import cn from 'classnames';
import {useFormikContext} from 'formik';
import React, {ChangeEvent, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {toast} from 'react-toastify';
import AdvertismentMap from '../../../../../components/advertisementMap';
import DotsLoading from '../../../../../components/dotsLoading';
import FormikLikeInput from '../../../../../components/formikFileds/likeInput';
import FormikTextArea from '../../../../../components/formikFileds/textArea';
import CustomCheckbox from '../../../../../components/mazraeKit/customCheckbox';
import TabbedDescriptionTextarea from '../../../../../components/TabbedDescriptionTextarea';
import {useAuth} from '../../../../../context/authContext';
import AccardionLike from '../../../../../module/newShop/advertisementRegisteration/accadionlikeAR';
import FloatingOnlySelectBottomSheet from '../../../../../module/newShop/advertisementRegisteration/floatingOnlySelectBottomSheet';
import useGetAdCatalog from '../../../../../services/hookService/getAdCatalog/useGetAdCatalog';
import {RootState} from '../../../../../store/redux';
import {
  clearAdminImages,
  clearAllData,
} from '../../../../../store/redux/addPictureAdvertisment';
import {
  addFormData,
  addOptionalFormData,
  addRegisterAdvertisement,
  clearBrandData,
  isSendingData,
  prevRoute,
  resetFormData,
} from '../../../../../store/redux/advertisementRegisteration';
import Num2persian from '../../../../../utilities/helper/convertNumToPersian';
import {ScrollSection} from '../../../../../utilities/helper/scrollToError/errorScroll.constants';
import roundLastThreeToZero from '../../../../../utilities/helper/unitConvertor/roundLastThreeToZero';
import {
  getAmountUnits,
  getPriceUnits,
} from '../../../../../utilities/helper/unitGenerator';
import {
  AdvertisementType,
  InputGroupCode,
  UnitTitle,
  UnitValue,
} from '../../../../../utilities/helper/unitGenerator/unit.types';
import {GroupNameToInputName} from '../../../advertisementList/utils';
import {CodeToInputGroupName} from '../../../myFavouriteAdd/card/helper';
import {groupTitle} from '../../constants';
import {FromikType, ISaleBuyRentService} from '../../types';
import AdditionalInfo from '../additionalInfo';
import AdvertisementUploadImage from '../advertisementUploadImage';
import FormulationBottomSheet from '../bottomsheetList/formulationBottomSheet';
import CommonField from '../commonField';
import FarmAdditionalMainInfo from './farmAdditionalMainInfo';
import {getUnitLabel} from './getUnitLabel';
import {getRestrictedInputGroups} from '../../../../../global/helpers/getRestrictedInputGroups';

function Sale({
  storePlanType,
  srs_type,
  setOpenInputListBottomSheet,
  isLoading,
  setIsEmptyFarmModal,
  guid,
}: ISaleBuyRentService) {
  const {supplierProfile} = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {setFieldValue, values, errors, setErrors, validateField} =
    useFormikContext<FromikType>();

  const {
    input,
    input_group,
    sub_input,
    brand_name,
    price,
    sub_brand_data,
    title,
    price_on_call,
    priceUnit,
    has_no_brand,
    available_quantity,
    min_sell_quantity,
    mode,
    ad_type,
    ...state
  } = useSelector((state: RootState) => state.advertisementRegisteration);

  const isPersonalAd = ad_type.value === 'personal';
  const restrictedInputGroups = getRestrictedInputGroups({
    adType: ad_type.value,
    storePlanType: storePlanType!,
    advertisementType: AdvertisementType.SALE,
  });

  useEffect(() => {
    // add a default value when user toggles price_on_call
    if (!price_on_call) {
      const defaultTimeUnit = getPriceUnits(
        AdvertisementType.SALE,
        input_group?.code as number,
        input?.code,
      )[0];
      defaultTimeUnit && setFieldValue('price_unit', defaultTimeUnit);

      return;
    }
    if (price_on_call) {
      dispatch(addRegisterAdvertisement({discount_amount: undefined}));
      setFieldValue('has_discount', false);
      setFieldValue('discount_amount', '');
    }
    dispatch(addRegisterAdvertisement({price: ''}));
    setFieldValue('ad_price', '');
    setFieldValue('price_unit', undefined);
  }, [price_on_call]);

  useEffect(() => {
    if (title && errors.title) {
      setErrors({...errors, title: undefined});
    }
  }, [title, errors]);

  const {addCatalogData} = useGetAdCatalog({parent: guid});

  const [touched, setTouched] = useState<boolean>(false);
  const [location, setLocation] = useState<ILocation>({
    lat: Number(supplierProfile?.latlong?.[0]),
    lng: Number(supplierProfile?.latlong?.[1]),
  });

  const isDiscountDisabled = !values?.ad_price || values?.price_on_call;
  const isPriceDisabled = values?.price_on_call;

  const [openFormulationBottomSheet, setOpenFormulationBottomSheet] =
    useState<boolean>(false);

  useEffect(() => {
    setFieldValue('location', location);
  }, [location]);

  const handleAccordionLike = (
    item: Omit<IInputGroup, 'title_description' | 'icon'>,
  ) => {
    dispatch(
      addRegisterAdvertisement({
        input_group: {
          guid: item.guid,
          code: item.code,
          type: CodeToInputGroupName[item.code],
        },
      }),
    );
    dispatch(
      addRegisterAdvertisement({
        input: undefined,
        sub_input: undefined,
      }),
    );
    dispatch(resetFormData(''));
    dispatch(clearBrandData());
    dispatch(clearAdminImages());
    dispatch(clearAllData());
    dispatch(addFormData(''));
  };

  const isFormulation =
    input_group &&
    (input_group?.code === 11 ||
      input_group?.code === 12 ||
      input_group?.code === 13);

  useEffect(() => {
    if (!input?.title) return;

    document.getElementById(ScrollSection.SUB_INPUT)?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [input?.title]);

  // Update formik fields value with state data
  useEffect(() => {
    if (sub_brand_data?.advertisement_title) {
      setFieldValue('title', sub_brand_data?.advertisement_title);
    }
    if (sub_brand_data?.advertisement_description) {
      setFieldValue('description', sub_brand_data?.advertisement_description);
    }
  }, [sub_brand_data]);

  const isLendTech = (): boolean => {
    const inputGroupCode = input_group?.code;
    const inputCode = input?.code;

    if (!inputGroupCode || !inputCode) return false;

    //  all groups except lab,farm and employee
    const groups = [11, 12, 13, 15, 16];

    return groups.includes(inputGroupCode);
  };

  const unitOptions = getAmountUnits(
    'sale' as AdvertisementType,
    input_group?.code as number,
    input?.code as number,
    sub_input?.code as number,
  );

  const resetBrandData = () => {
    dispatch(clearBrandData());
    dispatch(clearAdminImages());
    setFieldValue('sub_brand', undefined);
    setFieldValue('brand_name', undefined);
    setFieldValue('sub_brand_data', undefined);
  };

  const handleCheckBoxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;

    setFieldValue('has_no_brand', checked);

    dispatch(
      addRegisterAdvertisement({
        has_no_brand: checked,
      }),
    );

    if (checked) {
      resetBrandData();
    }
  };

  const handlePriceOnCallChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setFieldValue('price_on_call', isChecked);
    validateField('ad_price');

    dispatch(
      addRegisterAdvertisement({
        price_on_call: isChecked,
        ...(isChecked && {
          discount_amount: undefined,
          price: '',
        }),
      }),
    );

    if (isChecked) {
      // Clear formik values
      setFieldValue('ad_price', '');
      setFieldValue('discount_amount', '');
      setFieldValue('has_discount', false);

      // Clean formData state
      if (state.formData) {
        try {
          const parsedFormData = JSON.parse(state.formData);
          delete parsedFormData.discount_amount;
          delete parsedFormData.has_discount;
          delete parsedFormData.ad_price;

          dispatch(addFormData(JSON.stringify(parsedFormData)));
        } catch (error) {
          console.error('Error cleaning formData:', error);
        }
      }

      // Also clear from advertisementRegisteration state
      dispatch(
        addRegisterAdvertisement({
          discount_amount: null,
        }),
      );
    }
  };

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (e.target.value) {
      const roundedValue = roundLastThreeToZero(Number(e.target.value));
      if (roundedValue?.toString() !== e.target.value) {
        setFieldValue('ad_price', roundedValue?.toString());
        dispatch(
          addRegisterAdvertisement({
            price: roundedValue?.toString(),
          }),
        );
      }
    }
  };

  const fullBrandName =
    sub_brand_data?.name && brand_name
      ? `${sub_brand_data.name} - ${brand_name}`
      : sub_brand_data?.name ?? brand_name ?? null;

  // Static conditions
  const toolsUnitDisabledCondition =
    input_group?.code === InputGroupCode.TOOL && !sub_input;

  const machineryHideUnitCondition =
    input_group?.code === InputGroupCode.MACHINERY &&
    unitOptions.length <= 2 &&
    unitOptions.every(
      item =>
        item.value === UnitValue.DEVICE || item.value === UnitValue.NUMBER,
    );
  const toolsHideUnitCondition =
    input_group?.code === InputGroupCode.TOOL &&
    unitOptions.length === 1 &&
    unitOptions[0].value === UnitValue.NUMBER;
  const hideUnitCondition =
    toolsHideUnitCondition || machineryHideUnitCondition;

  useEffect(() => {
    if (hideUnitCondition) {
      setFieldValue('quantity_pack', 1);
      if (toolsHideUnitCondition) {
        setFieldValue('quantity_pack_unit', {
          title: UnitTitle.NUMBER,
          value: UnitValue.NUMBER,
        });
      } else if (machineryHideUnitCondition) {
        setFieldValue('quantity_pack_unit', {
          title: UnitTitle.DEVICE,
          value: UnitValue.DEVICE,
        });
      }
    }
  }, [hideUnitCondition]);
  return (
    <div className="flex flex-col gap-3">
      <section>
        <p className="mt-3 text-md">{groupTitle[srs_type.type]}</p>
        {addCatalogData &&
          addCatalogData[0]?.input_Group_object?.map(
            (item: IInputGropuList, index: number) => {
              return (
                <AccardionLike
                  key={item.guid ?? item.code ?? index}
                  logo={item.image}
                  title={item.title}
                  disable={
                    isPersonalAd
                      ? false
                      : !restrictedInputGroups.includes(item.code)
                  }
                  active={input_group?.code === item.code}
                  activeInput={
                    input_group?.code === item.code ? input : undefined
                  }
                  onClick={() => {
                    handleAccordionLike(item);
                    setOpenInputListBottomSheet(true);
                    setTouched(false);
                    dispatch(addOptionalFormData(''));
                    dispatch(addFormData(''));
                    dispatch(addRegisterAdvertisement({}));
                  }}
                  onRemoveItem={() => {
                    dispatch(
                      addRegisterAdvertisement({
                        input: undefined,
                        sub_input: undefined,
                      }),
                    );
                    dispatch(addFormData(''));
                  }}
                />
              );
            },
          )}
      </section>

      {/* ----------------------------------- Sub input ----------------------------------- */}

      {input?.title && (
        <>
          {input?.title !== 'فروش مزرعه' && (
            <section className="flex flex-col" id={ScrollSection.SUB_INPUT}>
              <div className="flex mb-2 text-gray-900 font-Medium">
                {input_group?.type === 'fertilizer' ||
                input_group?.type === 'pesticide' ? (
                  <span className="text-md">
                    نوع{' '}
                    {input_group?.type &&
                      GroupNameToInputName[input_group?.type]}{' '}
                    {input?.title} را وارد کنید.
                  </span>
                ) : (
                  <span className="text-md">
                    {' '}
                    نوع {input?.title} را وارد کنید.
                  </span>
                )}
                <span className="text-red-400">*</span>
              </div>
              <div
                className={cn(
                  'bg-white w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center',
                  {
                    'border-red-550': touched && errors.sub_input?.title,
                    '!border-farm-shop-500':
                      values.sub_input?.title && !errors.sub_input?.title,
                  },
                )}
              >
                {!sub_input?.title && (
                  <i className="mx-1 text-xl text-gray-700 icon-nameSearch" />
                )}
                <input
                  className="w-full text-md text-gray-950 placeholder:text-gray-700"
                  name="sub_input"
                  readOnly={true}
                  value={sub_input?.title}
                  placeholder="انتخاب نوع"
                  onClick={() => {
                    navigate('/advertisement-register-subInput-list', {
                      state: {
                        input: input?.guid,
                        backRoute: '/advertisement-registeration',
                      },
                    });
                  }}
                ></input>
              </div>
              <span className="pt-1 text-xs text-red-550">
                {touched && errors.sub_input?.title}
              </span>
            </section>
          )}

          {/* ------------------------------------------------------------------------ */}
          {/*//* --------------------------- BRAND NAME ------------------------------ */}
          {/* ------------------------------------------------------------------------ */}
          {
            // Show brand select for all groups EXPECT farm
            input_group?.type !== 'farm' && (
              <section
                className={`flex flex-col gap-2 ${
                  mode === 'edit' && 'opacity-40 pointer-events-none'
                }`}
              >
                <div
                  className={`flex text-gray-900 font-Medium ${
                    values?.has_no_brand || !sub_input?.guid
                      ? ' opacity-40'
                      : ''
                  }`}
                  id={ScrollSection.SUB_INPUT}
                >
                  <p className="mb-0 font-medium color-gray-1 text-md">
                    برند محصول<span className="text-red-400">*</span>
                  </p>
                </div>
                <div
                  className={cn(
                    'w-full h-12 rounded border-[1px] border-gray-700 px-2 flex items-center relative',
                    values.sub_brand && 'valid',
                    !values?.has_no_brand && 'bg-white ',
                    (values?.has_no_brand || !sub_input?.guid) &&
                      ' opacity-40 pointer-events-none',
                  )}
                >
                  <i className="absolute left-1 mx-1 text-xl text-gray-700 icon-nameArrow---Down-2-1" />
                  <input
                    className={cn(
                      'text-md text-gray-950 w-full',
                      (values?.has_no_brand || !sub_input?.guid) &&
                        'bg-gray-50 pointer-events-none',
                    )}
                    name="brand_name"
                    readOnly={true}
                    value={fullBrandName ?? ''}
                    placeholder="برند محصول را انتخاب کنید"
                    disabled={values?.has_no_brand || !sub_input?.guid}
                    onClick={() => {
                      dispatch(prevRoute(`${window.location.pathname}`));
                      navigate('/advertisement-register-brand-list', {
                        state: {
                          input: input?.guid,
                          backRoute: '/advertisement-registeration',
                        },
                      });
                    }}
                  />
                </div>
                <CustomCheckbox
                  name="has_no_brand"
                  title="محصول فاقد برند"
                  titleClass=" !text-md !font-medium"
                  customClass="mt-2"
                  onChange={handleCheckBoxChange}
                  disabled={!sub_input?.guid}
                  checked={
                    values?.has_no_brand ??
                    (mode === 'edit' && Boolean(!brand_name))
                  }
                />
              </section>
            )
          }
          {/* ------------------------------------------------------------------------ */}
          {/* ------------------------ ADVERTISEMENT TITLE --------------------------- */}
          {/* ------------------------------------------------------------------------ */}

          <section id={ScrollSection.TITLE}>
            <p className="mb-2 font-medium color-gray-1 text-md">
              عنوان آگهی <span className="text-red-400">*</span>
            </p>
            <FormikLikeInput
              name="title"
              label=""
              value={values.title || title || ''}
              placeholder="عنوان آگهی"
              touched={!!values.title || !!title}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                setFieldValue('title', e.target.value);
                dispatch(addRegisterAdvertisement({title: e.target.value}));
              }}
            />
            <span className="mt-1 text-xs text-gray-900">حداکثر 45 حرف</span>
          </section>

          {/* -------------------------------- Weight & Quantity -------------------------------- */}
          {isLendTech() && !hideUnitCondition && (
            <section
              className={cn(
                toolsUnitDisabledCondition && 'opacity-40 pointer-events-none',
              )}
              id={ScrollSection.QUANTITY_PACK}
            >
              <div className="flex">
                <p className="mb-2 color-gray-1 text-md font-medium w-[68%]">
                  مقدار بسته بندی
                  <span className="text-red-400">*</span>
                </p>

                <p className="mb-2 font-medium color-gray-1 text-md">
                  واحد<span className="text-red-400">*</span>
                </p>
              </div>
              <CommonField
                disabled={unitOptions?.length === 0}
                touched={touched}
                type="number"
                inputName="quantity_pack"
                bottomSheetName={'quantity_pack_unit'}
                label=""
                showUnitWhileDisabled={true}
                firstInputPlaceHolder={'مقدار را وارد کنید'}
                placeholder={unitOptions?.length > 0 ? 'واحد ' : ''}
                commonBottomSheetData={unitOptions}
                shouldDispatch={true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('quantity_pack', e.target.value);
                  dispatch(
                    addRegisterAdvertisement({
                      quantity_pack: e.target.value,
                    }),
                  );
                }}
              />
            </section>
          )}

          {isLendTech() && (
            <>
              <section id={ScrollSection.AVAILABLE_QUANTITY}>
                <p className="mb-2 font-medium color-gray-1 text-md">
                  <span>
                    موجودی فروشگاه (
                    {getUnitLabel({
                      inputGroupCode: input_group?.code ?? null,
                      inputCode: input?.code ?? null,
                    })}
                    )
                  </span>
                  <span className="text-red-400"> * </span>
                </p>
                <FormikLikeInput
                  name="available_quantity"
                  label=""
                  type="number"
                  value={values.available_quantity || available_quantity || ''}
                  placeholder={`موجودی فروشگاه را ${getUnitLabel({
                    inputGroupCode: input_group?.code ?? null,
                    inputCode: input?.code ?? null,
                  })} بسته وارد کنید`}
                  touched={!!values.available_quantity || !!available_quantity}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('available_quantity', Number(e.target.value));
                    dispatch(
                      addRegisterAdvertisement({
                        available_quantity: Number(e.target.value),
                      }),
                    );
                  }}
                />
              </section>

              <section id={ScrollSection.AVAILABLE_QUANTITY}>
                <p className="mb-2 font-medium color-gray-1 text-md">
                  <span>
                    حداقل سفارش (
                    {getUnitLabel({
                      inputGroupCode: input_group?.code ?? null,
                      inputCode: input?.code ?? null,
                    })}
                    )
                  </span>
                  <span className="text-red-400"> * </span>
                </p>
                <FormikLikeInput
                  name="min_sell_quantity"
                  label=""
                  type="number"
                  value={values.min_sell_quantity || min_sell_quantity || ''}
                  placeholder={`حداقل سفارش بر ${getUnitLabel({
                    inputGroupCode: input_group?.code ?? null,
                    inputCode: input?.code ?? null,
                  })} را وارد کنید`}
                  touched={!!values.min_sell_quantity || !!min_sell_quantity}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    setFieldValue('min_sell_quantity', Number(e.target.value));
                    dispatch(
                      addRegisterAdvertisement({
                        min_sell_quantity: Number(e.target.value),
                      }),
                    );
                  }}
                />
              </section>
            </>
          )}

          {/* ----------------------------- Advertsiement Description ----------------------------- */}

          <section id={ScrollSection.DESCRIPTION}>
            {isLendTech() ? (
              <>
                <TabbedDescriptionTextarea />
              </>
            ) : (
              <>
                <FormikTextArea
                  name="description"
                  placeholder=""
                  className="!text-md"
                  description=""
                  label="توضیحات"
                  value={values.description || ''}
                  rows={5}
                  labelClass="!text-md font-medium"
                  customOnChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                    setFieldValue('description', e.target.value);
                    dispatch(
                      addRegisterAdvertisement({description: e.target.value}),
                    );
                  }}
                />
                <span className="text-xs text-gray-900">
                  جزئیات و نکات قابل توجه محصول را بنویسید.
                </span>
              </>
            )}
          </section>

          {/* ----------------------------------- Other Section ----------------------------------- */}

          {input_group?.code === 15 && (
            <section>
              <p className="mb-2 font-medium color-gray-1 text-md">
                قدرت موتور را وارد کنید.(اسب بخار)
              </p>
              <FormikLikeInput
                name="engine_power"
                label="قدرت موتور(اسب بخار)"
                disabled={false}
                required={false}
                type="number"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFieldValue('engine_power', e.target.value);
                }}
              />
            </section>
          )}
          <FarmAdditionalMainInfo
            {...{
              input,
              input_group,
              sub_input,
              touched,
              srs_type,
              setIsEmptyFarmModal,
            }}
          />

          {/* ------------------------------------ Formulation ------------------------------------ */}

          {isFormulation && (
            <FloatingOnlySelectBottomSheet
              value={values?.type?.title}
              title={input_group.code === 13 ? 'نوع محصول' : 'فرمولاسیون'}
              onClick={() => {
                setFieldValue('type', {
                  title: values?.type?.title,
                  value: values?.type?.value,
                });
                setOpenFormulationBottomSheet(true);
              }}
              Placeholder={input_group.code === 13 ? 'نوع محصول' : 'فرمولاسیون'}
            />
          )}

          {/* ----------------------------------- Price Section ----------------------------------- */}

          <section
            id={ScrollSection.AD_PRICE}
            className={isPriceDisabled ? 'opacity-40' : ''}
          >
            <p className="mb-2 font-medium color-gray-1 text-md">
              قیمت{' '}
              {isLendTech() ? (
                <>
                  <span className="ml-1 font-normal text-md text-zinc-500">
                    (هر یک بسته)
                  </span>
                  <span className="text-red-400">*</span>
                </>
              ) : (
                <span className="text-red-400">*</span>
              )}
            </p>
            <CommonField
              touched={touched}
              type="number"
              inputName="ad_price"
              bottomSheetName={'price_unit'}
              label=""
              placeholder="قیمت هر بسته را وارد کنید"
              leftLabel="تومان"
              commonBottomSheetData={
                values.price_on_call
                  ? []
                  : getPriceUnits(
                      state?.srs_type?.type,
                      input_group?.code as number,
                      input?.code,
                    )
              }
              disabled={values.price_on_call}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                if (e.target.value.length < 12) {
                  setFieldValue('ad_price', e.target.value);
                  dispatch(addRegisterAdvertisement({price: e.target.value}));
                }
              }}
              onBlur={handleOnBlur}
            />

            {values.ad_price && (
              <span className="text-xs text-farm-shop-500">
                {values?.price_unit?.title}{' '}
                {Num2persian(values.ad_price?.toString())} تومان
              </span>
            )}
          </section>
          {ad_type?.value === 'personal' && (
            <CustomCheckbox
              name="price_on_call"
              title="تماس بگیرید"
              onChange={handlePriceOnCallChange}
              checked={values?.price_on_call ?? false}
            />
          )}

          {/* ---------------------------------- Discount Section ---------------------------------- */}

          <section
            id={ScrollSection.DISCOUNT}
            className={isDiscountDisabled ? 'opacity-40' : ''}
          >
            <span className="font-medium text-md">تخفیف</span>
          </section>
          <section className={isDiscountDisabled ? 'opacity-40' : ''}>
            <FormikLikeInput
              name="discount_amount"
              label=""
              placeholder="میزان تخفیف را وارد کنید"
              leftLabel="درصد"
              disabled={!values?.ad_price || values?.price_on_call}
              required={true}
              type="number"
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value;
                if (value === '') {
                  setFieldValue('discount_amount', '');
                  return;
                }

                const numericValue = Number(value);

                setFieldValue('has_discount', true);

                if (numericValue <= 100) {
                  setFieldValue('discount_amount', value);
                } else {
                  setFieldValue('discount_amount', 100);
                }
              }}
            />
            {values.discount_amount && (
              <span className="text-xs text-farm-shop-500">
                {Num2persian(values.discount_amount)} درصد تخفیف
              </span>
            )}
          </section>

          {/* ----------------------------------- Images Section ---------------------------------- */}

          <AdvertisementUploadImage
            onClick={() => dispatch(addFormData(JSON.stringify(values)))}
          />

          {/* ------------------------------- Other Specifications ------------------------------- */}

          <section>
            <FloatingOnlySelectBottomSheet
              Placeholder="سایر مشخصات(اختیاری)"
              wrapperClass="border-gray-700"
              onClick={() => {
                navigate('/optional-registeration-info');
                dispatch(addFormData(JSON.stringify(values)));
              }}
            />
            <AdditionalInfo />
          </section>

          {/* ---------------------------------- Location Area ---------------------------------- */}

          <section className="flex flex-col">
            <span className="mb-3 text-md">محدوده آگهی</span>
            <div className="z-0 edit-ads-map">
              <AdvertismentMap
                center={location}
                selectLocation={location => {
                  setLocation(location);
                  setFieldValue('location', location);
                }}
              />
              <span className="pt-1 text-xs text-red-550">
                {errors?.location?.lat}
              </span>
            </div>
          </section>
          <section className="pr-1">
            <CustomCheckbox
              name="only_massage_buyer"
              title="فقط اجازه ارسال پیام به خریدار داده شود."
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                setFieldValue('only_massage_buyer', e.target.checked)
              }
              checked={values?.only_massage_buyer}
            />
            <div className="flex flex-wrap gap-2 mt-3"></div>
          </section>

          <button
            className={cn('mb-3 w-full h-12 text-white rounded', {
              'bg-farm-shop-200': isLoading,
              'bg-farm-shop-500': !isLoading,
            })}
            type="submit"
            disabled={isLoading}
            onClick={() => {
              dispatch(addFormData(JSON.stringify(values)));
              dispatch(isSendingData(true));
              setTouched(true);

              if (Object.keys(errors).length > 0) {
                // Show validation errors for each field
                const showErrors = (errorObj: Record<string, any>) => {
                  Object.entries(errorObj).forEach(([field, message]) => {
                    if (typeof message === 'string') {
                      toast.error(`${message}`, {autoClose: 2000});
                    } else if (typeof message === 'object') {
                      // Recursively handle nested error objects
                      showErrors(message);
                    }
                  });
                };
                showErrors(errors);
              }
            }}
          >
            {isLoading ? <DotsLoading /> : 'ثبت آگهی'}
          </button>
        </>
      )}

      {isFormulation && (
        <FormulationBottomSheet
          {...{
            openFormulationBottomSheet,
            setOpenFormulationBottomSheet,
          }}
        />
      )}
    </div>
  );
}

export default React.memo(Sale);
